// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__26xAu","buttons":"RemoveExpirationActionButtons_buttons__CI4we"};